/**
 * /onboarding/expired — link scaduto, gia usato o non valido.
 *
 * Messaggio sempre generico per non leakare dettagli interni
 * (decisione PR4: "Lo studio ti contatterà se ci sono problemi").
 */

import { OnboardingShell } from '../components/OnboardingShell';

export function OnboardingExpiredPage() {
  return (
    <OnboardingShell>
      <div className="text-center py-8 md:py-16">
        <div
          className="w-16 h-16 mx-auto mb-6 rounded-full bg-error-container flex items-center justify-center"
          aria-hidden="true"
        >
          <span className="material-symbols-outlined text-on-error-container text-3xl">
            link_off
          </span>
        </div>
        <h1 className="text-2xl md:text-3xl font-semibold text-text-main mb-3">
          Link non piu' valido
        </h1>
        <p className="text-text-secondary text-base md:text-lg mb-3">
          Questo link di onboarding e' scaduto oppure e' gia stato utilizzato.
        </p>
        <p className="text-text-secondary text-sm md:text-base">
          Contatta lo studio per ricevere un nuovo invito.
        </p>
        <a
          href="mailto:stucchi@studiodietetico.eu"
          className="inline-block mt-6 px-6 py-3 rounded-lg bg-primary text-on-primary text-base font-semibold min-h-[44px]"
        >
          Contatta lo studio
        </a>
      </div>
    </OnboardingShell>
  );
}
